<template lang="pug">
  .container.center-box
    table.table.table-sm
      thead.thead-light
        tr
          th(scope="col") 年度
          th(scope="col") 補助案件名稱
          th(scope="col-sm-5") 活動名稱
          th(scope="col-md-auto") 最後維護日
          th(scope="col-md-auto") 資料維護
          th(scope="col-sm-1") 目前狀態
          th(scope="col") 成果上傳

      tbody
        tr(v-for="e in dataList" :key="e.id")
          td {{e.year}}
          td(style="width: 15rem;")  {{e.grant_name}}
          td(style="width: 18rem;")  {{e.activity_name}}
          td {{e.update_time}}
          td
            button.btn.btn-outline-primary.bi.bi-pencil-fill.gy(
              v-if="e.check_flag == 0"
              @click="goEditPage('Maintain', e.id, e.activity_name)"
              type="button"
            ) 資料維護
            button.btn.btn-outline-primary.bi.bi-pencil-fill.gy(
              v-if="e.check_flag == 2"
              @click="goEditPage('Maintain', e.id, e.activity_name)"
              type="button"
            ) 請補件上傳
            span(v-if="e.check_flag == 1").badge.badge-secondary(style="width: 6rem;") 已停止維護
            //- span(v-if="e.check_flag == 2").badge.badge-danger(style="width: 6rem;") 無法使用
          td
            span(v-if="e.check_flag == 0").badge.badge-light(style="width: 6rem;") 未檢視
            span(v-if="e.check_flag == 1 && e.final_flag == 0").badge.badge-success(style="width: 6rem;") 核准-待結案
            span(v-if="e.check_flag == 1 && e.final_flag == 2").badge.badge-danger(style="width: 6rem;") 已結案-未核准
            span(v-if="e.check_flag == 1 && e.final_flag == 1").badge.badge-primary(style="width: 6rem;") 已結案
            span(v-if="e.check_flag == 2").badge.badge-warning(style="width: 6rem;") 不受理
            //- span(v-if="e.final_flag == 0").badge.badge-danger(style="width: 6rem;") 不受理
            //- span(v-if="e.final_flag == 1").badge.badge-danger(style="width: 6rem;") 不受理
            //- span(v-if="e.final_flag == 2").badge.badge-danger(style="width: 6rem;") 不受理

          td
            button.btn.btn-outline-info.bi.bi-pencil-fill.gy(
              v-if="e.final_flag == 1"
              @click="goUploadPage('Maintain', e.id, e.activity_name)"
              type="button"
            ) 上傳成果
            span(v-if="e.final_flag == 0 && e.check_flag == 0").badge.badge-secondary(style="width: 6rem;") 待審中
            span(v-if="e.final_flag == 0 && e.check_flag == 2").badge.badge-danger(style="width: 6rem;") 無法使用
            span(v-if="e.final_flag == 0 && e.check_flag == 1").badge.badge-secondary(style="width: 6rem;") 待執行結案
            span(v-if="e.final_flag == 2 && e.check_flag == 1").badge.badge-danger(style="width: 6rem;") 已結案-未核准




    MyPagination(v-bind="pagination" @update:page="setPage")

  </template>

  <script>
  import MyPagination from '@/components/MyPagination'

  import { fetchGrantApplicationList } from '@/api/client/Grant'

  export default {
    components: { MyPagination },
    data () {
      return {
        u_str: null,
        dataList: [],
        pagination: {
          page: 1,
          max: 1,
          take: 15,
        },
      }
    },
    methods: {
      setPageMax (total) {
        this.pagination.max = Math.ceil(total / this.pagination.take)
      },
      async fetchDataList (page) {
        const now = new Date()
        const { data, total_num } = await fetchGrantApplicationList({
          type: 1, u_str: this.u_str, page
        })
        this.setPageMax(total_num)
        this.dataList = data.map(e => {
          const { check_flag, final_flag, grant_endtime, grant_starttime } = e
          const canUpload = final_flag === 1
          const isTimeOk = new Date(grant_endtime) > now && new Date(grant_starttime) < now
          const canMaintain =[0, 2].includes(check_flag) && isTimeOk
          return {
            ...e,
            canUpload,
            canMaintain
          }
        })
      },
      async setPage (p) {
        this.pagination.page = +p
        await this.fetchDataList(+p)
      },
      async goEditPage(name, id, activity_name) {
        console.log(name, id, activity_name)
        this.$router.push({
          path:'/artedu1872/subsidy/maintain',
          query: {id, activity_name}
        })
      },
      async goUploadPage(name, id, activity_name) {
        console.log(name, id, activity_name)
        this.$router.push({
          path:'/artedu1872/subsidy/upload',
          query: {id, activity_name}
        })
      },

    },
    async mounted () {
      const user = sessionStorage.getItem('user')
      if (!user) {
        this.$router.push({ path: '/artedu1872/subsidy/loginNow' })
        return
      }
      const { u_str } = JSON.parse(user)
      this.u_str = u_str
      if (!u_str) {
        this.$router.push({ path: '/artedu1872/subsidy/loginNow'  })
        return
      }
      await this.fetchDataList(1)
    }
  }
  </script>

  <style lang="sass" scoped>
  </style>



// WEBPACK FOOTER //
// src/views/Artedu1872/components/UploadData/DataList.vue